import { errorLogger } from '@ajaibid/utils';

export function logFetchError(error) {
  if (error.code === '406') {
    errorLogger('ERROR_API_WAF', error.message, error);
    return;
  }

  errorLogger('ERROR_API', error.message, error);
}
